module.exports = __webpack_public_path__ + "static/media/tax-breakdown-table-column-demo.ff5d77d9.png";